class LabObservationDto {
    public Id: string;
    public DateTime: Date;
    public CategoryLookupId: string = "";
    public Analysis: string = "";
    public ReferenceLow: string = "";
    public ReferenceHigh: string = "";
    public Result: string = "";
    public Units: string = "";
    public Level: LabObservationLevel | null = null;

    constructor(model?: Partial<LabObservationDto>) {
        Object.assign(this, model);
    }
}

enum LabObservationLevel {
    /// <summary>Normal result</summary>
    Normal = "Normal",

    /// <summary>High result</summary>
    High = "High",

    /// <summary>Critically high result</summary>
    CriticallyHigh = "CriticallyHigh",

    /// <summary>Low result</summary>
    Low = "Low",

    /// <summary>Critically low result</summary>
    CriticallyLow = "CriticallyLow",

    /// <summary>Abnormal result</summary>
    Abnormal = "Abnormal"
}

const LabObservationLevelLabels: Record<LabObservationLevel, string> = {
    [LabObservationLevel.Normal]: "N",
    [LabObservationLevel.High]: "H",
    [LabObservationLevel.CriticallyHigh]: "HH",
    [LabObservationLevel.Low]: "L",
    [LabObservationLevel.CriticallyLow]: "LL",
    [LabObservationLevel.Abnormal]: "A"
};

export { LabObservationDto, LabObservationLevel, LabObservationLevelLabels };
